import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'absentGradient'
})
export class AbsentGradientPipe implements PipeTransform {
    /**
     * Creates a CSS linear-gradient background based on startMinutes and endMinutes
     * within a workday range of 9:00 (540 min) to 17:00 (1020 min).
     *
     * @param color - The color to use for the absent period
     * @param startMinutes - Start of absence in minutes from midnight
     * @param endMinutes - End of absence in minutes from midnight
     * @returns CSS background value (gradient or solid color)
     */
    transform(color: string | null, startMinutes: number, endMinutes: number): string | null {
        if (!color) return null;

        const dayStart = (startMinutes >= (5 * 60) && startMinutes <= (9 * 60)) ? startMinutes : (9 * 60);
        const dayEnd = dayStart + (8 * 60);   // 17:00
        const totalMinutes = dayEnd - dayStart; // 480

        // Clamp to workday boundaries
        const clampedStart = Math.max(startMinutes, dayStart);
        const clampedEnd = Math.min(endMinutes, dayEnd);

        // If entire workday is covered, return solid color
        if (clampedStart <= dayStart && clampedEnd >= dayEnd) {
            return color;
        }

        // Calculate percentages
        const startPercent = ((clampedStart - dayStart) / totalMinutes) * 100;
        const endPercent = ((clampedEnd - dayStart) / totalMinutes) * 100;

        return `linear-gradient(to right, transparent ${startPercent}%, ${color} ${startPercent}%, ${color} ${endPercent}%, transparent ${endPercent}%)`;
    }
}

